import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { useToast } from '../../../controller/ToastController';
import HotelEditRoomType from './HotelEditRoomType';
import HotelController, { RoomListType } from '../../../controller/HotelController';
import StoreController, { CurrentStoreContext } from '../../../controller/StoreController';
import ConfirmModal from '../../../components/modal/ConfirmModal';

const HotelAddRoomType = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [roomName, setRoomName] = useState<string>('');
  const [roomList, setRoomList] = useState<RoomListType[]>([]);
  const [addRoom, setAddRoom] = useState<boolean>(false);
  const [editRoom, setEditRoom] = useState<boolean>(false);
  const [editRoomList, setEditRoomList] = useState<RoomListType>();
  const [selectedAreaGradeId, setSelectedAreaGradeId] = useState<number | null>(null);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const onChangeRoomName = (e: any) => {
    setRoomName(e.target.value);
  };

  const addRoomButton = () => {
    setAddRoom(true);
    setEditRoom(false);
  };
  const editRoomButton = (room: RoomListType) => {
    setEditRoomList(room);
    setEditRoom(true);
    setAddRoom(false);
  };
  const deleteClick = (area_grade_id: number) => {
    setSelectedAreaGradeId(area_grade_id);
    setVisibleConfirm(true);
  };
  const confirmDelete = () => {
    if (selectedAreaGradeId !== null) {
      delRoomType(selectedAreaGradeId);
    }
    setVisibleConfirm(false);
  };

  const getRoomType = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes: any = await HotelController.getRoomType(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        setRoomList(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const setRoomType = async () => {
    if (roomName === '') {
      showToast('객실그레이드명을 입력해주세요.', 'error');
    } else {
      try {
        const params = {
          store_id: currentStore.value,
          area_grade_name: roomName,
          area_id: [],
        };
        const response = await HotelController.setRoomType(params);
        if (response && response.data.ok) {
          showToast('객실그레이드가 추가되었습니다.');
          setRoomName('');
          setAddRoom(false);
          getRoomType();
        } else {
          showToast('다시 시도해주세요.', 'error');
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };
  const delRoomType = async (gradeId: number) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        area_grade_id: gradeId,
      };
      const oRes: any = await HotelController.delRoomType(oParams);

      if (oRes && oRes.data.ok) {
        showToast('삭제되었습니다.');
        getRoomType();
        setEditRoom(false);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getRoomType();
  }, []);

  return (
    <Style>
      <div className={` ${editRoom ? 'contentContainer twin' : 'contentContainer'}`}>
        <div className="title">
          <h4>객실 그레이드 안내</h4>
        </div>
        {roomList && roomList.length > 0 ? (
          roomList.map((data, index) => (
            <div key={index} className="roomListBoxWrap">
              <div className="roomListBox">
                <div className="header">
                  <div className="flex">
                    <div className="numberBox">
                      <p>{index + 1}</p>
                    </div>
                    <h2>{data.area_grade_name}</h2>
                  </div>
                  <div className="flex">
                    <p className="roomCount">{data.count} 객실</p>
                    <button onClick={() => editRoomButton(data)}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`} alt="수정아이콘" />
                    </button>
                    <button onClick={() => deleteClick(data.area_grade_id)}>
                      <img src={`${process.env.PUBLIC_URL}/svg/ic_delete.svg`} alt="삭제아이콘" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="roomListBox noneList">
            <h2>등록된 객실이 없습니다.</h2>
          </div>
        )}
        <button className="plusRoomTypeButton" onClick={addRoomButton}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="추가아이콘" />
          <p>새 그레이드 만들기</p>
        </button>
        {addRoom && (
          <div className="addRoomType">
            <input
              type="text"
              placeholder="객실 그레이드명을 입력해주세요"
              value={roomName}
              onChange={onChangeRoomName}
            />
            <button onClick={setRoomType} className="submitButton">
              객실 만들기
            </button>
          </div>
        )}
      </div>
      {editRoom && (
        <div className="contentContainer">
          <HotelEditRoomType
            roomData={editRoomList}
            setEditRoom={setEditRoom}
            refresh={getRoomType}
          />
        </div>
      )}
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={confirmDelete}
      />
    </Style>
  );
};

export default HotelAddRoomType;

const Style = styled.div`
  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #979797;
  }
  input {
    width: 100%;
    padding: 11px 27px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }
  .contentContainer.twin {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  /* title */
  .title {
    margin-bottom: 20px;
    color: #555;
  }

  /* plusRoomTypeButton */
  .plusRoomTypeButton {
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px;
    border: 1px solid #4dd2ae;
    border-radius: 5px;

    p {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #4dd2ae;
    }
  }

  /* addRoomType */
  .addRoomType {
    margin-top: 46px;
    .submitButton {
      width: 100%;
      margin-top: 24px;
    }
  }

  /* roomListBox */
  .roomListBox {
    margin-top: 22px;
    border: 1px solid #cecece;
    border-radius: 5px;

    .header {
      display: flex;
      justify-content: space-between;
      padding: 12px 27px;

      h2 {
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .roomListContent {
    padding: 2px 27px 12px 27px;

    .flex {
      margin-top: 10px;
      justify-content: space-between;
    }
  }
  .numberBox {
    min-width: 24px;
    min-height: 24px;
    margin-right: 16px;
    padding: 2px 7px;
    border: 1px solid #4dd2ae;
    border-radius: 3px;

    p {
      color: #40977f;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .roomCount {
    margin-right: 40px;
  }
  .noneList {
    padding: 50px 0;
    text-align: center;

    h2 {
      color: #cecece;
      font-weight: 400;
    }
  }
  @media (max-width: 650px) {
    .roomListBox .header h2 {
      max-width: 300px;
    }
    .roomCount {
      margin-right: 4px;
    }
  }
  @media (max-width: 550px) {
    .roomListBox .header h2 {
      max-width: 220px;
    }
  }
  @media (max-width: 450px) {
    .roomListBox .header h2 {
      max-width: 120px;
    }
  }
`;
